import http from "../http-common";

// Public, unauthenticated calls (the token is the credential) — bypasses
// http-common's default "/api" baseURL the same way authService.js's
// reset-password/activate-account calls do, by passing an absolute URL.
class MediaUploadLinkService {
  baseUrl = process.env.VUE_APP_API_URL;

  validate = (token) => http.get(this.baseUrl + `/nl/upload-links/${token}`);

  // Step 1: upload files, get back classification/extraction results to
  // review — nothing is a real message yet.
  analyze = (token, files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    return http.post(this.baseUrl + `/nl/upload-links/${token}/analyze`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  // Step 2: patient has reviewed/corrected the fields — this is what
  // actually creates the message staff will see.
  confirm = (token, files, caption) =>
    http.post(this.baseUrl + `/nl/upload-links/${token}/confirm`, { files, caption });
}

export default new MediaUploadLinkService();
